var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconoNotificaciones(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_ionic-ios-notifications",
    "data-name": "Icon ionic-ios-notifications",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.5,
    height: 25.64,
    viewBox: "0 0 20.5 25.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15460",
    "data-name": "Trazado 15460",
    d: "M17.993,32.063c2.187,0,3.382-1.547,3.382-3.727H14.6C14.6,30.516,15.8,32.063,17.993,32.063Z",
    transform: "translate(-7.755 -6.423)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15461",
    "data-name": "Trazado 15461",
    d: "M27,22.513c-.987-1.273-2.929-2.019-2.929-7.72,0-5.851-2.64-8.2-5.1-8.768-.231-.056-.4-.132-.4-.37V5.473a1.564,1.564,0,0,0-3.127,0v.182c0,.232-.167.314-.4.37-2.467.571-5.1,2.916-5.1,8.768,0,5.7-1.942,6.441-2.929,7.72a1.243,1.243,0,0,0,1.019,1.994h17.95A1.243,1.243,0,0,0,27,22.513Z",
    transform: "translate(-6.761 -3.93)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoNotificaciones);
export default __webpack_public_path__ + "static/media/icono-notificaciones.5dc0effe9794d49650e4214e708ccc60.svg";
export { ForwardRef as ReactComponent };